// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Homepage from './Homepage';
import WordGame from './WordGame';
import Pebbles from './Pebbles';
import KnightTourGenerator from './puzzlegenerator';

function App() {
  return (
    <Routes>
      {/* Homepage with game picker */}
      <Route path="/" element={<Homepage />} />

      {/* Word game route */}
      <Route path="/wordgame" element={<WordGame />} />

      {/* Pebbles game route */}
      <Route path="/pebbles" element={<Pebbles />} />

      {/* Knight tour generator route */}
      <Route path="/generator" element={<KnightTourGenerator />} />
    </Routes>
  );
}

export default App;